<template>
  <header class="header">
    <commercial-break />
    <modals />
    <messages />
    <div class="sr-only" aria-live="assertive" aria-atomic="true">
      {{ statusMessage }}
    </div>
    <div class="container" v-if="languageLoaded">
      <a class="sr-only btn btn-plain" :aria-label="$t('header.availabilityAdjust.skipToContentLabel')" href="#page-title-for-sr">{{ $t('header.availabilityAdjust.skipToContent') }}</a>
      <div class="header-wrapper">
        <div class="logo" role="img" :aria-label="$t('header.availabilityAdjust.logoTitle')"></div>
        <div class="header-info">
          <session-timer v-if="isDataSet" />
        </div>
        <div class="header-menu">
          <languages v-if="!isLoading" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Messages from '@/base/components/Header/Messages'
import SessionTimer from '@/base/components/Header/SessionTimer'
import { mapState, mapGetters } from 'vuex'
import Languages from '@/base/components/Header/Languages'
import Modals from '@/base/components/Header/Modals'
import EventBus from '@/base/event-bus'
import CommercialBreak from '@/base/components/Ads/CommercialBreak.vue'

export default {
  name: 'AppHeader',
  components: {
    CommercialBreak,
    Modals,
    Languages,
    SessionTimer,
    Messages
  },
  data () {
    return {
      languageLoaded: false,
      showSuccessMessage: false,
      loadingTriggered: false,
      frozenLoadingText: ''
    }
  },
  computed: {
    ...mapState({
      paymentLoading: state => state.payment.loading,
      confirmationLoading: state => state.confirmation.loading,
      isDataSet: state => !!(state.payment.paymentData),
      isLangLoading: state => state.lang.loading,
      paymentData: state => state.payment.paymentData
    }),
    ...mapGetters({
      isErrorDataSet: 'isErrorDataSet'
    }),
    isLoading () {
      return this.paymentLoading || this.confirmationLoading || this.isLangLoading || (!this.paymentData && !this.isErrorDataSet)
    },
    statusMessage () {
      if (this.isLangLoading) {
        return this.frozenLoadingText
      }
      return this.showSuccessMessage ? this.$t('header.availabilityAdjust.langChanged') : ''
    }
  },
  watch: {
    isLangLoading (val, oldVal) {
      if (val) {
        this.frozenLoadingText = this.$t('header.availabilityAdjust.langLoading')
        this.loadingTriggered = true
      } else {
        this.frozenLoadingText = ''
        if (oldVal === true && this.loadingTriggered) {
          this.showSuccessMessage = true
          this.loadingTriggered = false
          setTimeout(() => {
            this.showSuccessMessage = false
          }, 3000)
        }
      }
    }
  },
  created () {
    EventBus.$on('language-loaded', () => {
      this.languageLoaded = true
    })
  }
}
</script>
